import { createMuiTheme, withTheme} from '@material-ui/core/styles';

export  const customFont = createMuiTheme({
    typography: {
     "fontFamily": `"Hp Simplified", "Helvetica Neue", sans-serif`
    }
 });